<template>
	<div id="configInt">
		<el-form
			ref="form"
			:rules="rules"
			:model="form"
			label-width="120px"
			inline
		>
			<!-- 数据长度 -->
			<el-form-item
				class="formItem"
				label="数据长度(字节)"
				prop="byteLen"
			>
				<el-tooltip
					effect="dark"
					content="最大16"
					placement="top-start"
				>
					<el-input-number
						type="number"
						class="formInput"
						size="small"
						v-model.trim="form.byteLen"
						placeholder="最大16"
						:step="1"
						:max="16"
						:min="1"
					></el-input-number>
				</el-tooltip>
			</el-form-item>
			<!-- 取值范围 -->
			<el-form-item class="formItem" label="取值范围" prop="bounds">
				<div class="formInput">
					<el-input-number
						type="number"
						@input="handleBounds"
						:min="0"
						v-model.trim="min"
						class="formInputSmall"
						size="small"
						placeholder="最小值"
						@keydown.native="channelInputLimit"
					></el-input-number>
					<span class="betweenInput">~</span>
					<el-input-number
						type="number"
						v-model.trim="max"
						:min="min"
						@input="handleBounds"
						class="formInputSmall"
						size="small"
						placeholder="最大值"
						@keydown.native="channelInputLimit"
					></el-input-number>
				</div>
			</el-form-item>
			<!-- 步长 -->
			<el-form-item class="formItem" label="步长" prop="step">
				<el-tooltip
					effect="dark"
					content="指在取值范围内进行变化的值之间的间隔是多少距离"
					placement="top-start"
				>
					<el-input-number
						@keydown.native="channelInputLimit"
						:min="1"
						:step="1"
						v-model="form.step"
						class="formInput"
						size="small"
						placeholder="步长值,默认1"
						type="number"
					></el-input-number>
				</el-tooltip>
			</el-form-item>
			<!-- 倍数 -->
			<el-form-item class="formItem" label="倍数" prop="multiple">
				<el-tooltip
					effect="dark"
					content="如:10，则设备上报的数据解析除以这个倍数，下发给设备则需要乘以这个倍数；整数类型默认为1，小数类型根据小数位进行"
					placement="top-start"
				>
					<el-input-number
						:min="0"
						@keydown.native="channelInputLimit"
						type="number"
						v-model="form.multiple"
						class="formInput"
						size="small"
						placeholder="倍数关系,如:10，则上报的数据除以这个倍数"
					></el-input-number>
				</el-tooltip>
			</el-form-item>
			<!-- 单位 -->
			<el-form-item class="formItem" label="单位" prop="unit">
				<el-tooltip
					effect="dark"
					content="单位预设，中英文区分"
					placement="top-start"
				>
					<el-input v-model.trim="form.unit"></el-input>
				</el-tooltip>
			</el-form-item>
			<!-- 读写类型 -->
			<el-form-item class="formItem" label="读写类型" prop="rw">
				<el-radio-group v-model="form.rw">
					<el-radio :label="3">读写</el-radio>
					<el-radio :label="1">只读</el-radio>
				</el-radio-group>
			</el-form-item>
			<!-- 数据处理 -->
			<el-form-item class="formItem" label="数据处理" prop="dataProcess">
				<el-tooltip
					effect="dark"
					content="仅展示：数据仅在设备详情页的参数列表中显示即可，上报并更新此参数。仅统计：数据上报后需要存贮作为后续统计图使用。统计并展示：设备详情页的参数列表中只显示当前最新的状态，其余存储作为历史。数据不处理：默认，即不做业务逻辑处理"
					placement="top-start"
				>
					<el-select v-model="form.dataProcess">
						<el-option
							v-for="item in dataProcessList"
							:key="item.value"
							:value="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-tooltip>
			</el-form-item>
			<!-- 描述 -->
			<el-form-item class="formItem" label="描述" prop="description">
				<el-input
					v-model="form.description"
					maxlength="256"
					placeholder="请输入"
					type="textarea"
					class="formInput"
					size="small"
				></el-input>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: "configInt",
	data() {
		const checkByteLen = (rule, value, callback) => {
			if (value < 1 || value > 16) {
				callback(new Error("数据长度范围在1-16"));
			} else {
				callback();
			}
		};
		return {
			max: 0,
			min: 0,
			form: {
				byteLen: 1, // 数据长度
				bounds: "", // 取值范围
				step: 1, // 步长
				multiple: null, // 倍数
				dataProcess: 1, // 数据处理
				unit: "", // 单位
				rw: null, // 读写类型
				description: "", // 描述
			},
			dataProcessList: [
				{
					value: 1,
					label: "不处理",
				},
				{
					value: 2,
					label: "统计",
				},
				{
					value: 3,
					label: "展示",
				},
				{
					value: 4,
					label: "展示与统计",
				},
			],
			rules: {
				byteLen: [
					{
						required: true,
						message: "请填写数据长度",
						trigger: "change",
					},
					{ validator: checkByteLen, trigger: "blur" },
				],
				dataProcess: [
					{
						required: true,
						message: "请选择数据处理方式",
						trigger: "change",
					},
				],
				bounds: [
					{
						required: true,
						message: "请填写完整取值范围",
						trigger: "change",
					},
				],
				step: [
					{
						required: true,
						message: "请填写步长",
						trigger: "change",
					},
				],
				multiple: [
					{
						required: true,
						message: "请填写倍数",
						trigger: "change",
					},
				],
				unit: [
					{
						required: true,
						message: "请填写单位",
						trigger: "change",
					},
				],
				rw: [
					{
						required: true,
						message: "请选择读写类型",
						trigger: "change",
					},
				],
			},
		};
	},
	methods: {
		assignForm: function (form) {
			for (let i in this.form) {
				this.form[i] = form[i];
			}
			if (form.dataProcess == null) {
				form.dataProcess = 1;
			}
			this.max = form.bounds ? JSON.parse(form.bounds).max : "";
			this.min = form.bounds ? JSON.parse(form.bounds).min : "";
		},
		handleSubmit: function () {
			let result;
			this.$refs.form.validate((valid) => {
				if (valid) {
					result = this.form;
				} else {
					result = false;
				}
			});
			return result;
		},
		handleBounds: function () {
			let str = "";
			let max = Number(this.max),
				min = Number(this.min);
			if (max > min) {
				str = JSON.stringify({
					min: min,
					max: max,
				});
				this.$set(this.form, "bounds", str);
			}
		},
		close: function () {
			this.$refs.form.resetFields();
			this.max = "";
			this.min = "";
		},
		channelInputLimit(e) {
			let key = e.key;
			// 不允许输入'e'和'.'
			if (key === "e" || key === ".") {
				e.returnValue = false;
				return false;
			}
			return true;
		},
	},
};
</script>

<style scoped>
.formInput {
	width: 200px;
}
.formItem {
	width: 45%;
}
.formInputSmall {
	width: 120px;
}
.betweenInput {
	display: inline-block;
	width: 60px;
	text-align: center;
	font-size: 20px;
}
</style>